import React from 'react';
import { Instagram, Music2 } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <img 
            src="/amr-logo.png" 
            alt="AMR Logo" 
            className="footer-logo"
          />
          <p className="footer-tagline">
            Born from passion. Built for the world.
          </p>
        </div>

        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul className="footer-links">
            <li><a href="/#artists">Artists</a></li>
            <li><a href="/#events">Events</a></li>
            <li><a href="/#releases">Releases</a></li>
            <li><a href="/benefits">Benefits</a></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Connect</h4>
          <div className="social-links">
            <a href="https://instagram.com/anyonemusicrecords" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <Instagram size={24} />
            </a>
            <a href="https://open.spotify.com/label/anyonemusicrecords" target="_blank" rel="noopener noreferrer" aria-label="Spotify">
              <Music2 size={24} />
            </a>
            <a href="https://soundcloud.com/anyonemusicrecords" target="_blank" rel="noopener noreferrer" aria-label="SoundCloud">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M11.56 8.87V17h8.76c1.85 0 3.35-1.5 3.35-3.35s-1.5-3.35-3.35-3.35c-.37 0-.73.06-1.07.18-.49-2.42-2.64-4.25-5.18-4.25-1.33 0-2.55.49-3.51 1.28v10.49h1V8.87zm-1 0c-.96-.79-2.18-1.28-3.51-1.28-2.54 0-4.69 1.83-5.18 4.25-.34-.12-.7-.18-1.07-.18C-.85 11.66-2.35 13.16-2.35 15s1.5 3.35 3.35 3.35h8.76V8.87z"/>
              </svg>
            </a>
          </div>
        </div>

        <div className="footer-section">
          <h4>Newsletter</h4>
          <p className="newsletter-text">Stay updated on releases & events</p>
          <form className="newsletter-form" onSubmit={(e) => e.preventDefault()}>
            <input 
              type="email" 
              placeholder="Your email" 
              className="newsletter-input"
              required
            />
            <button type="submit" className="newsletter-btn">Subscribe</button>
          </form>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {currentYear} Anyone Music Records. All rights reserved.</p>
        <div className="footer-bottom-links">
          <a href="/privacy">Privacy Policy</a>
          <span>•</span>
          <a href="/terms">Terms of Service</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
